module.exports = __webpack_public_path__ + "img/check2.2deff1ed.svg";